import React from 'react';
import { Button, Card, Typography, Space } from 'antd';
import { useNavigate } from 'react-router-dom';
import { WalletOutlined, ArrowRightOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

const TestPurchaseCredits = () => {
  const navigate = useNavigate();

  const handleDirectAccess = () => {
    // 直接跳转到购买积分页面
    window.location.href = '/purchase-credits';
  };

  const handleRouterNavigate = () => {
    // 使用 React Router 导航
    navigate('/purchase-credits');
  };

  return (
    <div style={{ 
      padding: '40px', 
      maxWidth: '800px', 
      margin: '0 auto',
      background: '#f5f5f5',
      minHeight: '100vh'
    }}>
      <Card style={{ marginBottom: '24px' }}>
        <Title level={2}>Purchase Credits Page Test</Title>
        <Text type="secondary">
          Test different ways to access the purchase credits page
        </Text>
      </Card>

      <Card>
        <Title level={3}>Access Methods</Title>
        <Space direction="vertical" size="large" style={{ width: '100%' }}>
          <div>
            <Title level={4}>Method 1: Direct URL Access</Title>
            <Text>Enter the following URL directly in the browser address bar:</Text>
            <div style={{ 
              background: '#f0f0f0', 
              padding: '12px', 
              borderRadius: '4px',
              margin: '8px 0',
              fontFamily: 'monospace'
            }}>
              {window.location.origin}/purchase-credits
            </div>
            <Button 
              type="primary" 
              icon={<ArrowRightOutlined />}
              onClick={handleDirectAccess}
              style={{ marginTop: '8px' }}
            >
              Direct Jump
            </Button>
          </div>

          <div>
            <Title level={4}>Method 2: React Router Navigation</Title>
            <Text>Use React Router for in-page navigation:</Text>
            <Button 
              type="default" 
              icon={<WalletOutlined />}
              onClick={handleRouterNavigate}
              style={{ marginTop: '8px' }}
            >
              Navigate via Router
            </Button>
          </div>

          <div>
            <Title level={4}>Method 3: Open in New Window</Title>
            <Text>Open the purchase credits page in a new window:</Text>
            <Button 
              type="dashed" 
              onClick={() => window.open('/purchase-credits', '_blank')}
              style={{ marginTop: '8px' }}
            >
              Open in New Window
            </Button>
          </div>
        </Space>
      </Card>

      <Card style={{ marginTop: '24px' }}>
        <Title level={3}>Features</Title>
        <ul>
          <li><Text>Supports direct URL access: <code>/purchase-credits</code></Text></li>
          <li><Text>Requires user login authentication</Text></li>
          <li><Text>Automatically displays purchase credits modal</Text></li>
          <li><Text>Automatically returns to homepage after successful purchase</Text></li>
          <li><Text>Supports back button navigation</Text></li>
        </ul>
      </Card>
    </div>
  );
};

export default TestPurchaseCredits;
